<template>
  <v-btn
      class="my-2"
      :disabled="!isConnectedAndOnline"
      variant="tonal"
      :prepend-icon="mdiDatabaseArrowUpOutline"
      @click="dialog = true"
  >
    {{ $t('global.info-modal.label.load-db') }}
  </v-btn>
  <v-dialog
      v-model="dialog"
      max-width="500">

      <v-card >
        <v-card-title class="d-flex flex-column">
          <div>{{ $t('global.info-modal.label.choose-db') }}</div>
          <div>
          <v-btn
              :prepend-icon="mdiSync"
              size="x-small"
              class="mr-5"
              @click="getRemoteDBList()"
          >{{ $t('global.info-modal.label.refresh-list') }}</v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
              v-model="selectedDB"
              :items="dbList"
              item-title="createdAt"
              item-value="id"
              dense
              outlined
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-btn
              :disabled="!isConnectedAndOnline || !selectedDB"
              :loading="loading"
              @click="dialogConfirm = true"
          >OK</v-btn>
          <v-btn
            @click="dialog = false"
        >Cancel</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
  <replace-db-confirmation-modal
      :disabled="!isConnectedAndOnline || !selectedDB"
      :show="dialogConfirm"
      @close-dialog="dialogConfirm = false"
      @replace-db="replaceDb"
  />
</template>

<script setup>
import {mdiDatabaseArrowUpOutline, mdiSync} from '@mdi/js';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import {useStoreManager} from "@/stores/storeManager";
import ReplaceDbConfirmationModal from "./replaceDbConfirmationModal.vue";

const props = defineProps({
  isConnectedAndOnline: {
    required: true
  }
});
const emit = defineEmits(['dbSelected']);

const { t } = useI18n();
const storeManager = useStoreManager();

const dbList = ref([]);
const selectedDB = ref(null);
const dialogConfirm = ref(false);
const dialog = ref(false);
const loading = ref(false);

const getRemoteDBList = async () => {
  dbList.value = await storeManager.getRemoteDBList();
}

const replaceDb = async () => {
  loading.value = true;

  try {
    const output = await storeManager.getRemoteDB(selectedDB.value);
    if (output?.data) {
      await storeManager.replaceDB(output.data);
    }
    loading.value = false;
    dialog.value = false
  } catch (e) {
    console.error('Error loading db', e);
    loading.value = false;
  }
  dialogConfirm.value = false;
}

onMounted(() => {
  getRemoteDBList();
})
</script>